var _defs, _circle, _circle2, _circle3, _circle4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupporterCoin = function SvgSupporterCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "supporter-coin_svg__b",
    cx: 0.34,
    cy: 0.26,
    r: 0.55
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "supporter-coin_svg__a",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5C400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C98A12"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "url(#supporter-coin_svg__a)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.2,
    fill: "#23262A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.2,
    fill: "url(#supporter-coin_svg__b)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.2,
    stroke: "#7A5408",
    strokeWidth: 0.5,
    strokeOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#supporter-coin_svg__a)",
    transform: "matrix(.017 0 0 .017 3.296 2.837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m129 808 187-328 58 100-130.883 228H129ZM895.5 808l-187-328-58 100 130.883 228H895.5ZM523 618v185h-20V618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 808H422v-10h180zM636.5 348 512.66 134 389 348h247.5ZM388.5 434l123.84 214L636 434H388.5Z"
  }))));
};
export default SvgSupporterCoin;